import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionHeader } from 'components/common/override-rates/SectionHeader';
import { RatesComparisonCard } from 'components/common/uw-review/RatesComparisonCard';
import { useOverrideUwRatesPageStore } from 'store/pages/override-uw-rates/pageStore';
import { isRenewOrCancelProductLine } from 'global/services-helpers/enrollmentService';
import { ProductLineTitleV2Styled, SectionStyled } from './styles';

export const UnderwritingResultsSection: React.FC = observer(() => {
  const { uwResult, enrollmentModule, productLineId } = useOverrideUwRatesPageStore();

  return (
    <SectionStyled>
      <SectionHeader title="Underwriting Results" />
      <ProductLineTitleV2Styled productLineId={productLineId} />
      <RatesComparisonCard
        result={uwResult!}
        isRenewOrCancelProductLine={isRenewOrCancelProductLine(
          uwResult!.productLineId,
          enrollmentModule.enrollmentProposalData?.confirmedProposal,
        )}
      />
    </SectionStyled>
  );
});
